import React from "react";

export default function Reiki() {
  return (
    <div id="reiki" className="bg-[#EBE9E7] flex flex-col md:flex-row items-center p-6 sm:p-12 border-b-2 border-gray-100">
      {/* Text Section */}
      <div className="w-full md:w-1/2 md:pr-6 text-center md:text-left mb-6 md:mb-0">
        <h2 className="text-xl sm:text-2xl font-[20px] mb-4 font-bicyclete text-about-me-orange">
          What Is Reiki?
        </h2>
        <p className="about text-sm sm:text-base mb-3 text-gray-600 font-karla leading-[27px]">
        <span className="font-bold text-about-me-orange">Reiki</span> is a form of energy healing that taps into the universal life
          energy <span className="font-bold text-about-me-orange">(called "Ki")</span> to restore balance in your body and mind. During
          a session, the practitioner channels this energy through their hands,
          helping you relax, release tension, and reconnect with your inner
          peace. Reiki isn’t about fixing problems directly; it helps your body
          return to a state of balance, working on physical, emotional, and
          spiritual levels. People often experience deep relaxation, clarity,
          and emotional release, and many feel a sense of healing or
          transformation. Reiki is a gentle, yet powerful way to support your
          well-being and reconnect with your natural ability to heal. It is
          meant to complement, not replace, any medications or treatments
          prescribed by your healthcare provider.
        </p>
      </div>

      {/* Image Section */}
      <div className="w-full md:w-1/2 flex justify-center md:justify-end mb-6 md:mb-0">
        <img
          src="./sunrise.jpg"
          alt="Warm sunrise over a peaceful landscape" loading="lazy"
          className="rounded-lg shadow-lg w-full h-64 sm:h-80 md:h-full object-cover"
        />
      </div>
    </div>
  );
}